import { useCallback } from 'react';
import { useLogAnalyticsEvent } from 'shared/src/hooks/useLogAnalyticsEvent';

/**
 * Pull-to-refresh 시 호출. Android `GoodsListViewModel.swipeRefresh` 와 동일.
 * SCREEN 은 AnalyticsScreen context 에서 자동 주입.
 */
export const useLogRefreshScreen = () => {
  const logAnalyticsEvent = useLogAnalyticsEvent();
  return useCallback(() => {
    logAnalyticsEvent({
      name: 'REFRESH_SCREEN',
      analytics: { ACTION: 'PULL' },
    });
  }, [logAnalyticsEvent]);
};
